<template>
  <el-select
    v-model="dataValue"
    :clearable="clearable"
    style="width: 100%;"
    placeholder="请选择角色">
    <el-option
      v-for="item in operType"
      :key="item.key"
      :label="item.value"
      :value="item.key">
    </el-option>
  </el-select>
</template>
<script>
import { operType } from '../../index'
export default {
  name: 'OperTypeSelect',
  props: {
    value: { type: [String, Number], default: 20 },
    clearable: { type: Boolean, default: false }
  },
  data() {
    return { operType }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  }

}
</script>
